import React from "react";

// Updated professional images for each university
const UNIVERSITY_BACKGROUNDS = {
  "IIM Visakhapatnam":
    "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=1600&q=80",
  "IIM Tiruchirappalli":
    "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&w=1600&q=80",
  XLRI:
    "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=1600&q=80",
  "IIM Lucknow":
    "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&w=1600&q=80",
  "SP Jain School of Global Management":
    "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&w=1600&q=80",
  "E&ICT Academy IIT Kanpur":
    "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=1600&q=80",
  "E&ICT Academy IIT Guwahati":
    "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=1600&q=80",
};

export const ProgramCard = ({ item, handleClickOpen }) => {
  // Fallback university + program
  const universityName = item?.universityFullName || item?.university || 'Independent Program';
  const stripUniversityFromProgramName = (programName = '') => {
    if (!programName) return '';

    // 1) If it has " - " (IIM V - Senior Management Program)
    const dashIndex = programName.indexOf(' - ');
    if (dashIndex !== -1) {
      return programName.slice(dashIndex + 3).trim();
    }

    // 2) If it starts with a short prefix like "IIT G " or "IIM Trichy "
    //    remove first word or first two words heuristically
    const words = programName.split(' ');
    if (words.length > 2) {
      // handle patterns like "IIT G Executive ..." or "IIM Trichy Accelerated ..."
      if (words[0] === 'IIT' || words[0] === 'IIM' || words[0] === 'XLRI' || words[0] === 'IIMV') {
        // remove first 2 tokens for "IIT G", "IIM V", "IIM Trichy", "IIMV"
        return words.slice(2).join(' ').trim();
      }
    }

    return programName;
  };



  const coverImage =
    UNIVERSITY_BACKGROUNDS[universityName] || item?.cover_image;

  return (
    <div
      className="group relative w-full h-[300px] sm:h-[300px] overflow-hidden rounded-md bg-white shadow-md border border-[#e1e4f5] cursor-pointer"
      onClick={() => handleClickOpen && handleClickOpen(item)}
    >
      {/* IMAGE AREA */}
      <div className="relative h-[110px] md:h-[120px] overflow-hidden">
        <img
          src={item?.category_image_url || coverImage}
          alt={universityName}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />

        {/* Blue gradient overlay ON IMAGE ONLY */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2563EB]/0 to-[#2563EB]/0 group-hover:from-[#2563EB]/60 group-hover:to-[#2563EB]/30 transition-all duration-700" />

        {/* In Progress pill */}
        <div className="absolute top-3 right-4 z-10">
          <div className={`px-3 py-[4px] rounded-md text-[10px] font-semibold ${item.is_completed ? "text-white" : "text-[#2563EB]"} ${item.is_completed ? "bg-green-500" : "bg-white/95"} backdrop-blur-md border border-white/70 shadow`}>
            {item.is_completed ? "Completed" : "In Progress"}
          </div>
        </div>

        {/* ML badge */}
        <div className="absolute bottom-3 left-4 z-10">
          <div
            className="px-2 capitalize h-9 rounded-md flex items-center justify-center
                       text-[11px] font-semibold text-white bg-black/30
                       backdrop-blur-md border border-white/60
                       shadow-[0_4px_14px_rgba(15,23,42,0.35)]"
          >
            {item?.category_name
              ? item.category_name
                .trim()
                .split(/\s+/)
                .map(word => word.charAt(0).toUpperCase())
                .join('')
              : 'N/A'}
          </div>
        </div>
      </div>

      {/* CONTENT AREA */}
      <div className="bg-white px-5 pt-4 pb-4 flex flex-col h-[180px]">
        {/* University name */}
        <h3 className="text-xs font-normal text-gray-600 transition-colors duration-300 group-hover:text-[#2563EB] capitalize tracking-wide whitespace-nowrap truncate mb-1.5">
          {universityName}
        </h3>

        {/* Program name */}
        <h2 className="text-[14px] md:text-[16px] font-semibold text-black mb-3 leading-snug line-clamp-3">
          {stripUniversityFromProgramName(item?.program_name)}
        </h2>

        {/* Resume button pinned to bottom */}
        <button
          type="button"
          className="mt-auto w-full h-8 rounded-md bg-[#2563EB] text-white text-xs md:text-sm font-semibold flex items-center justify-center hover:bg-[#1D4ED8] transition-all duration-300 uppercase tracking-wide shadow-md hover:shadow-lg"
        >
          Resume
        </button>
      </div>
    </div>
  );
};
